import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Bank from "../components/Bank";

const EquityPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Bank Account' />

        {/* BlankPageLayer */}
        <Bank />
      </MasterLayout>
    </>
  );
};

export default EquityPage;
